import { INDICATOR_TYPE, USER_ROLE } from '~/constants';
import { formatMessage } from '~/i18n/translate';
import { ORDER_TYPE_SEND } from '~/store/modules/order/order-constants';

export const getUserRole = (userRole: string): string => {
  const roles = {
    [USER_ROLE.MANAGER]: formatMessage('recommendationMenagerLabel'),
    [USER_ROLE.SUPERVISOR]: formatMessage('recommendationSupervisorLabel'),
    [USER_ROLE.VENDOR]: formatMessage('recommendationVendorLabel')
  };

  return roles[userRole];
};

export const getOrderTypeSend = (orderTypeSend: string): string => {
  const types = {
    [ORDER_TYPE_SEND.BUDGET]: formatMessage('orderCreateCheckoutTypeBudget'),
    [ORDER_TYPE_SEND.ORDER]: formatMessage('orderCreateCheckoutTypeOrder')
  };

  return types[orderTypeSend];
};

export const getIndicators = (indicator: string): string => {
  const indicators = {
    [INDICATOR_TYPE.SALES]: 'Vendas',
    [INDICATOR_TYPE.PERCENTAGE_PROFIT]: 'Lucro percentual',
    [INDICATOR_TYPE.VALUE_PROFIT]: 'Lucro valor',
    [INDICATOR_TYPE.POSITIVATION]: 'Positivação',
    [INDICATOR_TYPE.POSITIVATION_MIX]: 'Mix Positivado'
  };

  return indicators[indicator];
};

export const isNumber = (value: any): boolean => {
  return typeof value === 'number' && Number.isFinite(value);
};
